import { AltRoute } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { IRideDto } from "@ryde/shared";

import { RideBottomBlockStyled } from "../ride.styled";

export interface IRideDetourIndicatorProps {
  rideDto?: Partial<IRideDto>;
}

export const RideDetourIndicator: FC<IRideDetourIndicatorProps> = ({
  rideDto,
}) => {
  const { t } = useTranslation();

  if (rideDto?.metadata?.inDetour !== true) {
    return null;
  }

  return (
    <RideBottomBlockStyled className="ride-detour-indicator">
      <FramerTooltip
        content={t("ride.INDICATORS.inDetourTooltip")}
        rtlStrippedBottomLeftPlacement
      >
        <span>
          <AltRoute className="ride-indicators__detour" />
        </span>
      </FramerTooltip>
    </RideBottomBlockStyled>
  );
};
